var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Author")]),_c('h2',[_vm._v("ID "+_vm._s(_vm.authorId))])])}
var staticRenderFns = []

export { render, staticRenderFns }